import styled from "styled-components/macro";

import { AccordionItem } from "components/AccordionItem";
import { SanitizedHtml } from "components/SanitizedHtml";
import type { ThemeProps } from "models/styles/theme";
import { ParagraphLarge } from "styles/elements/Texts";
import { Box } from "styles/helpers/layout";
import { calculateRem } from "styles/mixins/calculateRem";

export const StyledTestRecalculationModal = styled.div<ThemeProps>`
  background: ${({ theme }: ThemeProps) => theme.palette.neutral._950};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  height: 90vh;
  padding: ${calculateRem(32)};
  width: ${calculateRem(1000)};
  overflow-y: scroll;
`;

export const StyledDivider = styled(Box)`
  height: 1px;
  background-color: ${({ theme }: ThemeProps) => theme.palette.neutral._900};
  width: 100%;
`;

export const StyledColumn = styled(Box)`
  padding: 1rem;
`;

export const StyledColumnHeader = styled(ParagraphLarge)`
  padding: 1rem;
  font-weight: bold;
  text-align: center;
`;

export const StyledButtonContainer = styled(Box)`
  margin-top: ${calculateRem(32)};
  justify-content: center;
  display: flex;
`;

export const StyledSpinner = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const StyledAccordionItem = styled(AccordionItem)`
  .tab-content {
    padding: 0 1.5rem;
  }
`;

export const StyledQuestionPreview = styled(SanitizedHtml)`
  padding: 2rem;
  grid-column: 1 / span 5;
  background-color: ${({ theme }: ThemeProps) => theme.palette.secondary._950};
`;
